import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";

// 部分解除施設選択表示
// API仕様書_施設
import {
  IAPI_FAC018_Request,
  IAPI_FAC018_Response,
} from "../../../type/apiType";

// 部分解除施設選択表示API
// API仕様書_施設
const httpIAPI_FAC018 = async (
  param: IAPI_FAC018_Request
): Promise<IAPI_FAC018_Response> => {
  const res = await http.post(ApiUrl.API_FAC018, { ...param });
  return res.data;
};

export { httpIAPI_FAC018 };
